export const PropertyTypes = [
  { value: "Bungalow", title: "Bungalow" },
  { value: "Flat", title: "Flat" },
  { value: "Terraced", title: "Terraced" },
  { value: "Maisonette", title: "Maisonette" },
  { value: "SemiDetached", title: "Semi-Detached" },
  { value: "Detached", title: "Detached" },
];

export const PropertyStyles = [
  { value: "Purpose Built", title: "Purpose Built" },
  { value: "Converted", title: "Converted" },
];
